import { css } from "@emotion/react";

export const h1 = () => css`
    font-size: 3.5rem;
    font-weight: 500;
    line-height: 1.26;
`;

export const h2 = () => css`
    font-size: 3.2rem;
    font-weight: 900;
    line-height: 1.375;
`;

export const h3 = () => css`
    font-size: 2.3rem;
    font-weight: 900;
    line-height: 1.56;
`;

export const h4 = () => css`
    font-size: 2.3rem;
    font-weight: 300;
    line-height: 1.56;
`;

export const largeBodyCopy = () => css`
    font-size: 1.8rem;
    font-weight: 300;
    line-height: 1.27;
`;

export const smallBodyCopy = () => css`
    font-size: 1.6rem;
    font-weight: 300;
    line-height: 1.19;
`;

export const link = () => css`
    font-size: 2.3rem;
    font-weight: 300;
    line-height: 1.392;
`;

export const smallLink = () => css`
    font-size: 1.6rem;
    font-weight: 900;
    line-height: 1.8;
    letter-spacing: 0.0375em;
`;

export const caption = () => css`
    font-size: 1.6rem;
    font-weight: 700;
    line-height: 1.19;
`;

export const breadcrumb = () => css`
    font-size: 1.2rem;
    font-weight: 400;
    letter-spacing: 0.04rem;
    line-height: 1.67;
`;

export const highlight = ({ theme }) => css`
    font-size: 2.3rem;
    font-weight: 300;
    line-height: 1.65;

    @media (min-width: ${theme.breakpoints.mobileLandscape}) {
        font-size: 2.8rem;
    }

    @media (min-width: ${theme.breakpoints.desktop}) {
        font-size: 3.2rem;
    }
`;
